var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitefbicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#cc121d;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.152 -0.208)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(0.152 0.209)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.29 14.756)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M335.241,733.99V744.2a.266.266,0,0,0,.266.266H339.3a.266.266,0,0,0,.266-.266V733.824h2.749a.266.266,0,0,0,.265-.243l.264-3.126a.267.267,0,0,0-.265-.289h-3.013v-2.218a.941.941,0,0,1,.941-.941h2.119a.266.266,0,0,0,.266-.266v-3.126a.266.266,0,0,0-.266-.266h-3.58a3.8,3.8,0,0,0-3.8,3.8v3.014h-1.9a.266.266,0,0,0-.266.266v3.126a.266.266,0,0,0,.266.266h1.9Z",
    transform: "translate(-333.079 -723.348)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitefbicon);
export default __webpack_public_path__ + "static/media/whitefbicon.7bf1dae7be416cf7fde84d8d379a7bbb.svg";
export { ForwardRef as ReactComponent };